import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from "react-redux";
import { requestChangeMemberStatus } from "../../../../store/actionCreators/member";
import Avatar from '../../../Units/Avatar';

const PendingPlayerTab = ({ player, avatar }) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const changeMemberStatus = doAccept => {
    dispatch(requestChangeMemberStatus({
      memberId: player._id,
      doAccept
    }));
  };

  return (
    <div className={`pendingPlayerTab`}>
      <div className={`avatarContainer`}>
        <Avatar data={avatar} />
      </div>
      <div className={`clubInfo`}>
        <span className={`clubName`}>{player.username}</span>
        <p className={`id`}>{t('id')}: {player.globalAccountId} / {player._id}</p>
      </div>
      <div className={`actions`}>
        <button className={`decline`} onClick={() => changeMemberStatus(false)}></button>
        <button className={`accept`} onClick={() => changeMemberStatus(true)}></button>
      </div>
    </div>
  );
};

export default PendingPlayerTab;
